import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IrisFeatureFlags } from '@iris/common/modules/feature-flags/IrisFeatureFlags';
import { inject } from '@angular/core';
import { UnleashService } from '@karelics/angular-unleash-proxy-client';
import { TranslationKeysService } from '@iris/common/services/translation-keys.service';
import { IrisEnvironmentService } from '@iris/common/services/environment.service';

export class IrisTranslationLoader implements TranslateLoader {
  private readonly unleashService = inject(UnleashService);
  private readonly httpClient = inject(HttpClient);
  private readonly translationKeysService = inject(TranslationKeysService);
  private readonly envService = inject(IrisEnvironmentService);

  getTranslation(locale: string): Observable<TranslationObject> {
    if(this.unleashService.isEnabled(IrisFeatureFlags.STATIC_TRANSLATIONS_MESSAGE_SOURCE)) {
      return this.translationKeysService.getTranslationsByLanguage(locale);
    } else {
      return this.httpClient.get<TranslationObject>(`${window.location.origin}/translations/${locale}.json?v=${this.envService.env.version}`);
    }
  }
}
